export default function(data) {
var __t, __p = '', __e = _.escape;
__p += '\n<section>\n  <h4 class="headline-1">Thanks for reporting an issue!</h4>\n  <p>You\'re helping us make the web a better place to work and play. Tell your friends about the bug you just filed:</p>\n  <a class="button button-primary button-thanks"\n     href="https://twitter.com/intent/tweet?text=' +
__e( encodeURIComponent("I just filed a bug on the internet:") ) +
'&url=' +
__e( encodeURIComponent("https://webcompat.com/issues/") ) +
'' +
((__t = ( data.number )) == null ? '' : __t) +
'&via=webcompat"\n     target="_blank">Share on Twitter</a>\n  <p>You can return to this web page at any time to track the progress of this report.</p>\n</section>\n\n';
return __p
}